export default "__VITE_ASSET__8Kgb_fYe__"